import React from "react";
import { Icon as IconLib, IconProps } from "@iconify/react";

export const Icon = (props: IconProps) => {
  return (
    <>
      <IconLib {...props} mode="svg" className={props.className} icon={`icon-server:${props.icon}`} />
    </>
  );
};
